import React, { Fragment } from 'react';
import {
  string,
  func,
  number,
  bool,
} from 'prop-types';
import classNames from 'classnames/bind';

const Input = ({
  disabled,
  errorMessage,
  handleChange,
  handleOnBlur,
  handleOnKeyPress,
  id,
  label,
  maxLength,
  name,
  type,
  value,
}) => {
  const inputClassName = (val, err) => classNames({ filled: val, error: err });
  const style = disabled ? { backgroundColor: 'lightgrey' } : {};
  return (
    <Fragment>
      <div className="gcc-input">
        <input
          className={inputClassName(value, errorMessage)}
          disabled={disabled}
          id={id}
          maxLength={maxLength}
          name={name}
          onBlur={handleOnBlur}
          onChange={handleChange}
          onKeyPress={handleOnKeyPress}
          style={style}
          type={type}
          value={value}
        />
        <label htmlFor={id}>{label}</label>
      </div>
      { errorMessage && <span className="red f7 fw5" >{errorMessage}</span> }
    </Fragment>
  );
};

Input.defaultProps = {
  disabled: false,
  errorMessage: '',
  handleChange: () => { },
  handleOnBlur: () => { },
  handleOnKeyPress: () => { },
  id: '',
  label: '',
  maxLength: 50,
  name: '',
  type: 'text',
  value: null,
};

Input.propTypes = {
  disabled: bool,
  errorMessage: string,
  handleChange: func,
  handleOnBlur: func,
  handleOnKeyPress: func,
  id: string,
  label: string,
  maxLength: number,
  name: string,
  type: string,
  value: string,
};

export default Input;
